import { render, staticRenderFns } from "./NumberAccesses.vue?vue&type=template&id=04c7ba22&scoped=true&"
import script from "./NumberAccesses.vue?vue&type=script&lang=js&"
export * from "./NumberAccesses.vue?vue&type=script&lang=js&"
import style0 from "./NumberAccesses.vue?vue&type=style&index=0&id=04c7ba22&lang=scss&scoped=true&"
import style1 from "./NumberAccesses.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c7ba22",
  null
  
)

export default component.exports